import { getAuthorProfileBasedOnUid } from "@/api/search/searchUsernameByName";
import { ChallengeCard } from "@/features/challenge";
import { AuthorProfile } from "@/models/database/profiles/profile.model";
import { brand } from "branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { useEffect, useState } from "react";

export default function ProfileSingleChallenge({ props }: any) {
  const {
    created,
    createdBy,
    creatorType,
    endDate,
    fieldToCompare,
    game,
    goal,
    logoUrl,
    name,
    slug,
    startDate,
  } = props;
  const [author, setAuthor] = useState<AuthorProfile | null>(null);

  useEffect(() => {
    if (createdBy) {
      getAuthorProfileBasedOnUid(createdBy, brand.tenantId).then((author) => {
        setAuthor(author);
      });
    }
  }, [createdBy, brand.tenantId]);

  return (
    <ChallengeCard
      created={created}
      createdBy={createdBy}
      creatorType={creatorType}
      endDate={endDate}
      fieldToCompare={fieldToCompare}
      game={game}
      goal={goal}
      logoUrl={logoUrl}
      name={name}
      slug={slug}
      startDate={startDate}
      gameType={game}
      author={
        {
          slug: author ? author.slug : "",
          uid: createdBy,
          profileLogoUrl: author ? author.profileLogoUrl : "",
          userName: author ? author.userName : "",
          fullName: author ? author.fullName : "",
        } as AuthorProfile
      }
    />
  );
}
